import { render, staticRenderFns } from "./RolesInfoForm.vue?vue&type=template&id=b692b650&"
import script from "./RolesInfoForm.vue?vue&type=script&lang=js&"
export * from "./RolesInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports